import { ToastMessage, ToastMessageProps } from "@mlpa/core-ui-core-open_ocean_ui/Molecules/StatusTags/ToastMessage";
import React from "react";

const Toast: React.FC<ToastMessageProps> = ({ open, onClose, message, severity, ...rest }) => {
  return (
    <ToastMessage
      key="toastMessageGlobal"
      open={open}
      onClose={onClose}
      message={message}
      severity={severity}
      {...rest}
    />
  );
};

export default Toast;
